import RewardList from './reward.list';
import RewardShow from './reward.show';

export default {
  show: RewardShow,
  list: RewardList,
};
